import React from "react";
import Hero from "../../components/Hero/Hero";
import { imgGreenEarth, imgSustainability } from "../../assets/imgExport";
import { IconArrowRight } from "../../assets/svgExport";
import GetInTouch from "../../components/GetInTouch/GetInTouch";

export default function SustainabilityPage() {
  function HeroSection() {
    return (
      <div className="hero-container">
        <p className="subtitle">Protecting the environment</p>
        <h1>Our commitment to sustainability</h1>
        <p className="max-w-[70%] mx-auto">
          At Venti Maris, sustainability is at the core of everything we do. As
          a specialized provider of heavy marine transport solutions for the
          offshore renewable energy sector, particularly offshore wind, we
          recognize our responsibility to minimize environmental impacts and
          promote sustainable practices across our operations.
        </p>
      </div>
    );
  }

  function ResponsibleFleetSection() {
    const items = [
      "Fuel-efficient routing and voyage optimization",
      "Advanced cargo handling and stowage techniques",
      "Emission-reduction technologies onboard vessels",
    ];
    return (
      <div className="equal-flex">
        <div>
          <p className="subtitle">Smart, low-impact transport </p>
          <h2>Responsible Fleet Operations</h2>
          <div className="mt-8">
            <p className="leading-relaxed lg:mt-8">
              Our fleet comprises state-of-the-art heavy transport vessels,
              strategically selected to optimize fuel efficiency and reduce
              emissions. We continuously invest in innovative technologies and
              practices aimed at achieving greater sustainability, such as:
            </p>
            <ul className="w-full bg-gray-100 p-8 sm:whitespace-nowrap">
              {items.map((item, idx) => {
                return (
                  <div className="flex gap-2 items-center mb-4">
                    <IconArrowRight className="w-4 h-4" />
                    <li key={idx}>{item}</li>
                  </div>
                );
              })}
            </ul>
          </div>
        </div>
        <div className="relative">
          <img
            className="h-full w-full object-cover"
            src={imgGreenEarth}
            alt="green earth"
          />
          <div className="absolute inset-0 bg-gradient-to-tr from-[#080F3A]/40 to-[#05726B]/30" />
        </div>
      </div>
    );
  }

  function EnvironmentallySoundEngineeringSection() {
    const items = [
      {
        title: "Cargo Securing and Sea-Fastening",
        description:
          "Designing cargo securing and sea-fastening solutions that minimize waste and ensure safe, efficient reuse.",
      },
      {
        title: "Environmental Risk Assessments",
        description:
          "Conducting thorough environmental risk assessments to identify and mitigate potential impacts.",
      },
      {
        title: "Durability and Recyclability",
        description:
          "Implementing solutions to enhance the durability and recyclability of transport equipment.",
      },
    ];

    return (
      <div className="text-center">
        <p className="subtitle">Sustainable by design</p>
        <h2>Environmentally Sound Engineering</h2>
        <p className="max-w-[70%] mx-auto">
          Working closely with{" "}
          <a
            href="https://www.empireengineering.co.uk/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-main-light underline text-inherit-size"
          >
            Empire Engineering
          </a>
          , our sister company, we integrate environmental considerations into
          all stages of our transport engineering solutions:
        </p>
        <ul className="h-full flex flex-col md:flex-row gap-4 justify-between mt-20">
          {items.map((item, idx) => (
            <li key={idx}>
              <h3 className="mb-2 text-secondary-light">{item.title}</h3>
              <p>{item.description}</p>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  function SupportingRenewableEnergySection() {
    return (
      <div className="equal-flex">
        <div>
          <p className="subtitle">Powering the transition </p>
          <h2>Supporting Renewable Energy Growth</h2>
          <p>
            Venti Maris actively supports global renewable energy expansion by
            facilitating the safe and efficient transport of offshore wind
            infrastructure. By enabling the reliable delivery of wind farm
            components worldwide, we directly contribute to reducing the global
            carbon footprint and advancing clean energy goals.
          </p>
        </div>
        <div></div>
      </div>
    );
  }

  function ContinuousImprovementSection() {
    return (
      <div className="equal-flex border-t pt-32">
        <img
          src={imgSustainability}
          alt="illustration of green earth"
          className="order-2 md:order-1"
        />
        <div>
          <p className="subtitle">Always evolving</p>
          <h2>Continuous Improvement</h2>
          <p>
            We are committed to continuous improvement in sustainability
            practices. Our sustainability strategy includes regular reviews of
            our environmental performance, ongoing staff training, and
            collaborative initiatives with industry stakeholders to foster
            innovation in marine transport sustainability.
          </p>
        </div>
      </div>
    );
  }

  function PartnerWithUsSection() {
    return (
      <div className="equal-flex">
        <div>
          <h2>Partner With Us</h2>
          <p>
            Join Venti Maris in driving the sustainable future of offshore
            renewable energy. Together, we can achieve safer, smarter, and more
            sustainable marine transport solutions that benefit our planet.
          </p>
        </div>
        <div></div>
      </div>
    );
  }

  return (
    <div>
      <HeroSection />
      <div className="body-container">
        <ResponsibleFleetSection />
        <EnvironmentallySoundEngineeringSection />
        <SupportingRenewableEnergySection />
        <ContinuousImprovementSection />
        <PartnerWithUsSection />
        <GetInTouch />
      </div>
    </div>
  );
}
